/**
 * Icon Tokens
 */

import { text, accent } from "../semantic";

export const icon = {
  size: { xs: 14, sm: 18, md: 20, lg: 24, xl: 32, xxl: 40 },
  color: { 
    default: text.muted, 
    active: accent.primary, 
    forced: accent.forced, 
    accent: accent.secondary, 
    danger: accent.danger, 
    success: accent.success 
  },
} as const;
